import { CollapseProps } from "antd";

export const collapseItems: CollapseProps["items"] = [
  {
    key: "1",
    label: "نصب پنل خورشیدی چقدر هزینه دارد؟",
    children:
      "هزینه نصب پنل خورشیدی بستگی به ظرفیت سیستم، نوع پنل و محل نصب دارد. ما در «تابرق» بهترین قیمت‌ها را با کیفیت تضمینی ارائه می‌دهیم.",
  },
  {
    key: "2",
    label: "پنل خورشیدی چقدر برق تولید می‌کند؟",
    children:
      "میزان تولید برق به ظرفیت پنل، موقعیت جغرافیایی و شرایط آب و هوایی بستگی دارد. به طور متوسط هر کیلووات پنل خورشیدی روزانه بین ۴ تا ۵ کیلووات ساعت برق تولید می‌کند.",
  },
  {
    key: "3",
    label: "چند سال طول می‌کشد تا هزینه نصب پنل خورشیدی برگردد؟",
    children:
      "معمولا بازگشت سرمایه در سیستم‌های خورشیدی خانگی بین ۳ تا ۶ سال است، بسته به مصرف برق و شرایط فروش برق مازاد.",
  },
  {
    key: "4",
    label: "آیا نیاز به مجوز خاصی برای نصب پنل خورشیدی دارم؟",
    children:
      "بله، نصب نیروگاه خورشیدی متصل به شبکه نیازمند دریافت مجوزهای لازم از سازمان‌های مربوطه است که تیم «تابرق» این مراحل را برای شما انجام می‌دهد.",
  },
  {
    key: "5",
    label: "پنل‌های خورشیدی چقدر عمر می‌کنند؟",
    children:
      "عمر مفید پنل‌های خورشیدی معمولاً بین ۲۵ تا ۳۰ سال است، البته با نگهداری مناسب و نصب حرفه‌ای، عملکرد آن‌ها پایدار باقی می‌ماند.",
  },
  {
    key: "6",
    label: "آیا نصب پنل خورشیدی باعث کاهش قبض برق می‌شود؟",
    children:
      "بله، پنل خورشیدی بخش زیادی از برق مصرفی خانه را تامین می‌کند و در نتیجه قبض برق به طور قابل توجهی کاهش می‌یابد.",
  },
  {
    key: "7",
    label: "می‌توانم برق مازاد را به شبکه بفروشم؟",
    children:
      "بله، با طرح‌های متصل به شبکه می‌توانید برق مازاد تولید شده را به شرکت برق بفروشید و درآمد کسب کنید.",
  },
];